import { buildBindable } from '@monofe/di';
import type { IReducerRegister } from '../interface';
import { bindStoresReducer, injectStoresReducer, TYPES, unbindStoresReducer } from '../interface';
import register from './register';

export default buildBindable<IReducerRegister>({
    id: TYPES.IStoresReducer,
    bind: bindStoresReducer,
    remove: unbindStoresReducer,
    build: () => Promise.resolve(register()),
    inject: injectStoresReducer,
});
